import { useLanguage } from "../context/LanguageContext";
import { useRefonte } from "../translations/refonte";
import { useScrollReveal } from "../hooks/useScrollReveal";

/** Frise du pilote : la ligne se dessine au scroll, les jalons s'allument un par un. */
export const PilotTimeline = () => {
  const { language } = useLanguage();
  const p = useRefonte(language).pilotTimeline;
  const { ref, isRevealed } = useScrollReveal({ threshold: 0.35 });

  return (
    <div ref={ref} className="mt-12 pt-10 border-t border-white/10" data-testid="pilot-timeline">
      <p className="mono-cayus text-[#9ECEFA] mb-8">{p.label}</p>

      <div className="relative">
        {/* rail */}
        <div className="absolute left-0 right-0 top-[7px] h-[2px] bg-white/12 hidden md:block" />
        <div
          className="pilot-track-fill absolute left-0 top-[7px] h-[2px] bg-[linear-gradient(90deg,#5EB3F6,#F59E0B)] hidden md:block"
          style={{ width: isRevealed ? "100%" : "0%" }}
        />

        <div className="grid md:grid-cols-4 gap-8 md:gap-6">
          {p.steps.map((s, i) => (
            <div key={i} data-testid={`pilot-timeline-step-${i}`}>
              <span
                className={`pilot-node block w-4 h-4 rounded-full border-2 border-navy-900 mb-4 ${
                  isRevealed ? "bg-[#F59E0B] scale-100 opacity-100" : "bg-white/25 scale-75 opacity-50"
                }`}
                style={{ transitionDelay: `${300 + i * 320}ms` }}
              />
              <p className="mono-cayus text-[#F59E0B] mb-1.5">{s.w}</p>
              <p className="font-semibold text-white text-base mb-1">{s.t}</p>
              <p className="text-sm text-[#CFE6FC]/80">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PilotTimeline;
